module.exports = __webpack_public_path__ + "static/img/prizm_logo2.bd1e9c4a.png";